import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from './i18n';
import { USERS_COLLECTION } from '../shared/variables/collections';

/**
 * Seçili site dilini oturum açık kullanıcının profiline (`kullanici.dil`) yazar; sunucu push ve
 * e-posta bildirimlerini bu dilde üretir (tenis.io-functions notification-i18n). Yalnız değişince ve
 * aynı kullanıcı/dil için bir kez yazar; hata kullanıcıya gösterilmez (bildirim Türkçe kalır).
 */
export function useProfileLanguageSync(userData?: Pick<Users.User, 'id' | 'dil'> | null) {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'tr').slice(0, 2);
  const written = useRef('');
  useEffect(() => {
    const id = userData?.id;
    if (!id || !SUPPORTED_LANGUAGES.some(item => item.code === lang) || userData?.dil === lang)
      return;
    const key = `${id}:${lang}`;
    if (written.current === key) return;
    written.current = key;
    // Firestore yalnız giriş yapmış kullanıcıda gerekir; `_app` paketine girmesin diye geç yüklenir.
    import('./firestoreActions')
      .then(({ doc, updateDoc, firestore }) =>
        updateDoc(doc(firestore, USERS_COLLECTION, id), { dil: lang }),
      )
      .catch(() => {
        written.current = '';
      });
  }, [userData?.id, userData?.dil, lang]);
}
